import { ref } from "vue";
import { defineStore } from "pinia";
import CryptoJS from "crypto-js";

const SECRET_KEY =
  process.env.VUE_APP_PINIA_SECRET_KEY || "vIDOjgyxQRzH9Izb81lMhqhMUY9F6CWw";

const key = "products";

export const useProductsStore = defineStore(
  key,
  () => {
    // state

    const products = ref(null);

    // actions

    const set = (value) => {
      products.value = value;
    };

    const unset = () => {
      products.value = null;
    };

    return {
      products,
      set,
      unset,
    };
  },
  {
    persist: {
      key,
      storage: localStorage, // localStorage or sessionStorage
      serializer: {
        serialize: (value) =>
          CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString(),
        deserialize: (value) => {
          const bytes = CryptoJS.AES.decrypt(value, SECRET_KEY);
          const decrypted = bytes.toString(CryptoJS.enc.Utf8);
          return JSON.parse(decrypted);
        },
      },
    },
  },
);
